<template>
  <v-card>
    <v-card-title>
      フッターリンク編集

      <v-spacer />
      <v-btn icon @click='cancelEdit'>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text height='500'>
      <v-form ref='footerLinkForm' v-model='valid' lazy-validation>
        <v-row>
          <v-col md='12'>
            <v-row>
              <v-col md='3'>
                <v-text-field
                  v-model='footerLinkData.priority'
                  :rules='[positiveNumberPresenceValidation]'
                  class='mb-3'
                  type='number'
                >
                  <template v-slot:label>
                    <InputLabel label-name='優先度' :required='true' />
                  </template>
                </v-text-field>
              </v-col>
              <v-col md='8'>
                <v-alert dense outlined type='error' class='text-caption'>
                  ※1. 優先度は0が最高で、数が大きくなるほど低くなります<br />
                  ※2. 優先度が高いほど、フッターで先頭で表示されます。
                </v-alert>
              </v-col>
            </v-row>
          </v-col>
          <v-col md='12'>
            <v-text-field
              v-model='footerLinkData.title'
              :rules='[presenceValidation]'
              required
            >
              <template v-slot:label>
                <InputLabel label-name='リンクタイトル' :required='true' />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols='8'>
            <v-text-field
              v-if='!footerLinkData.pageable'
              v-model='footerLinkData.url'
              :rules='[presenceValidation, urlValidation]'
              required
            >
              <template v-slot:label>
                <InputLabel label-name='URL' :required='true' />
              </template>
            </v-text-field>
            <v-card v-else>
              <v-card-text>
                <a :href='pagePublicUrl(footerLinkData)' target='_blank'>{{ footerLinkData.pageable.title }} {{ pagePublicPath(footerLinkData) }}</a>
                <v-btn class='float-right' x-small icon @click='removePageable'>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols='2'>
            <SelectPageDialog @select='setPageable'>
              <template v-slot:activator='{ on, attrs }'>
                <v-btn color='primary' outlined v-bind='attrs' v-on='on'>
                  固定ページから設定
                </v-btn>
              </template>
            </SelectPageDialog>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col md='10' offset-md='1' sm='12'>
          <v-btn
            v-if='footerLink.id'
            color='primary'
            depressed
            block
            @click='update'
          >
            更新する
          </v-btn>
          <v-btn v-else color='success' depressed block @click='create'>
            作成する
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import SelectPageDialog from './SelectPageDialog'
import { mapState } from 'vuex'
import UrlUtils from '../../../mixins/url_utils'

export default {
  components: { InputLabel, SelectPageDialog },
  mixins: [formValidationUtils, UrlUtils],
  props: {
    footerLink: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      valid: true
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    }),
    footerLinkData: {
      get () {
        return this.footerLink
      },
      set (value) {
        this.$emit('change-footer-link', value)
      }
    }
  },
  methods: {
    validateForm () {
      this.valid = this.$refs.footerLinkForm.validate()
    },
    update () {
      this.validateForm()
      if (!this.valid) {
        return false
      }

      this.$emit('update', this.footerLink)
      this.valid = true
    },
    create () {
      this.validateForm()
      if (!this.valid) {
        return false
      }

      this.$emit('create', this.footerLink)
      this.valid = true
    },
    cancelEdit () {
      this.$refs.footerLinkForm.reset()
      this.$emit('cancel-edit')
    },
    setPageable (pageable) {
      this.$set(this.footerLinkData, 'pageable', pageable)
      this.footerLinkData.url = ''
    },
    pagePublicUrl (footerLink) {
      if (this.isHtmlPage(footerLink)) {
        return this.htmlPagePublicUrl(footerLink.pageable)
      }
      if (this.isMediaPage(footerLink)) {
        return this.mediaPagePublicUrl(footerLink.pageable)
      }
    },
    pagePublicPath (footerLink) {
      if (this.isHtmlPage(footerLink)) {
        return `/${this.htmlPagePath(footerLink.pageable)}`
      }
      if (this.isMediaPage(footerLink)) {
        return `/${this.mediaPagePath(footerLink.pageable)}`
      }
    },
    isHtmlPage (footerLink) {
      return footerLink.pageableType === 'HtmlPage' || footerLink.pageable.type === 'htmlPage'
    },
    isMediaPage (footerLink) {
      return footerLink.pageableType === 'MediaPage' || footerLink.pageable.type === 'mediaPage'
    },
    removePageable () {
      this.footerLinkData.pageable = null
    }
  }
}
</script>
